import { QueryKey } from '@shared/config';
import { useQuery } from '@tanstack/react-query';
import { economicActivityApi } from '../economicActivityApi';

export const useGetEconomicActivities = () => {
  return useQuery({
    queryKey: [QueryKey.GET_ECONOMIC_ACTIVITIES],
    queryFn: economicActivityApi.getEconomicActivities,
  });
};
